import { Injectable } from '@angular/core';
import { RestConnService, DsconfigService, StorageService } from '@services/services.module';
import { datesData } from '@pages/admin/calendarios/calendarios-bloqueo/block-day.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '@app/constants/constants';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarSelectDateService {
  private dates: any;

  constructor(
  private dsConfig: DsconfigService,
  private _res: RestConnService,
  private http: HttpClient,
  private storage: StorageService,
  ) {

  }

  exportExcel(url: string, data: datesData, params?: any) {
    console.log("empezando con nuevo método");
    let headerEmail = this.storage.get(Constants.UserData.email) || '';
    let headerProfileId = this.storage.get(Constants.UserData.profileId) || '';
    let headerEmployeeNumber = this.storage.get(Constants.UserData.employeeNumber) || '';
    let headerEmployeeName = this.storage.get(Constants.UserData.employeeName) || '';

    console.log("url",url);
    let headers = new HttpHeaders();
    if (headerEmail) headers = headers.set('email', headerEmail);
    if (headerProfileId) headers = headers.set('profileId', headerProfileId);
    if (headerEmployeeNumber) headers = headers.set('employeeNumber', headerEmployeeNumber);
    if (headerEmployeeName) headers = headers.set('name', headerEmployeeName);

    if (!params) {
      params = {
        dateEnd: data.dateEnd,
        dateInit: data.dateInit,
      };
    }


    // console.log("headers",headers);
    console.log("params",params);

    try
    {
      this.http
      .get(url, { headers, params, responseType: 'blob', observe: 'response' }) // Response as blob
      .pipe(
        catchError((error) => {
          console.error('Error occurred while exporting Excel:', error);
          return throwError(() => new Error('Failed to export Excel'));
        })
      )
      .subscribe((response) =>
      {
        let filename = 'export.xlsx'; // Default filename
        console.log("response.headers",response.headers);
        const contentDisposition = response.headers.get('Content-disposition');
        console.log("contentDisposition",contentDisposition);
        const matches = /filename="(.+)"/.exec(contentDisposition);
        if (matches != null && matches[1])
        {
          filename = matches[1];
        }


        const blob = new Blob([response.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' });
        const downloadURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = filename; // File name
        link.click();
      });
    } catch (error)
    {
      console.error('An unexpected error occurred:', error);
    }
  }


  getReport(data: datesData) {
    console.log("getReport - datesData",data);
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    console.log("dates",this.dates);
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }

  getExportAdminHours(data: datesData) {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/projectFee'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }

  getExportEmployeeHours(data: datesData) {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/employee/projectFee'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }

  getNoImputados(data: datesData) {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/missing'//?endDate=' + data.dateEnd + '&startDate=' + data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    const params = {
      endDate: data.dateEnd,
      startDate: data.dateInit,
    };
    this.exportExcel(this.dates.dates, data, params);
  }

  getHorasEmpleados(data: datesData, divisiones: any[]) {
    // let Url = '';
    // divisiones.forEach(
    //   element => {
    //     if (element.checked) {
    //       Url = Url + '&varDivisionCodigo=' + element.varDivCodigo;
    //     }
    //   }
    // );

    const params = {
      endDate: data.dateEnd,
      startDate: data.dateInit,
    };

    divisiones.forEach(
      element => {
        if (element.checked)
        {
          params['varDivisionCodigo'] = params['varDivisionCodigo'] || [];
          params['varDivisionCodigo'].push(element.varDivCodigo);
        }
      }
    );

    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/division'//?endDate=' + data.dateEnd + '&startDate=' + data.dateInit + Url
    };

    this.exportExcel(this.dates.dates, data, params);
  }
  getResponsibles(data: datesData, divisiones: any[]) {
    // let Url = '';
    // divisiones.forEach(
    //   element => {
    //     if (element.checked) {
    //       Url = Url + '&varDivisionCodigos=' + element.varDivCodigo;
    //     }
    //   }
    // );

    const params = {
      dateEnd: data.dateEnd,
      dateInit: data.dateInit
    };

    divisiones.forEach(
      element => {
        if (element.checked)
        {
          params['varDivisionCodigos'] = params['varDivisionCodigos'] || [];
          params['varDivisionCodigos'].push(element.varDivCodigo);
        }
      }
    );

    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/responsible'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit + Url
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data, params);
  }


  getDesvWorkingDay(data: datesData, divisiones: any[]) {
    // let Url = '';
    // divisiones.forEach(
    //   element => {
    //     if (element.checked) {
    //       Url = Url + '&varDivisionCodigos=' + element.varDivCodigo;
    //     }
    //   }
    // );

    const params = {
      dateEnd: data.dateEnd,
      dateInit: data.dateInit
    };

    divisiones.forEach(
      element => {
        if (element.checked)
        {
          params['varDivisionCodigos'] = params['varDivisionCodigos'] || [];
          params['varDivisionCodigos'].push(element.varDivCodigo);
        }
      }
    );

    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/desviation'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit + Url
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data, params);
  }

  getHorasClientes(data: datesData, divisiones: any[]) {
    let Url = '';


    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/customer'//?endDate=' + data.dateEnd + '&startDate=' + data.dateInit + Url
    };
    //window.open(this.dates.dates, '_blank');
    const params = {
      endDate: data.dateEnd,
      startDate: data.dateInit
    };

    divisiones.forEach(
      element => {
        if (element.checked)
        {
          params['varDivisionCodigo'] = params['varDivisionCodigo'] || [];
          params['varDivisionCodigo'].push(element.varDivCodigo);
        }
      }
    );

    this.exportExcel(this.dates.dates, data, params);
  }

  getInterventions(data: datesData) {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/intervention'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    const params = {
      dateEnd: data.dateEnd,
      dateInit: data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }

  getGuards(data: datesData): void {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/guard'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }

  /**
   * Call to the end-point to generate indident report
   * @param date initial and end date formated to create the url to call the end-point
   */
  getIncidentReport(data: datesData): void {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/incidents'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }

    /**
   * Call to the end-point to generate indident report
   * @param date initial and end date formated to create the url to call the end-point
   */
  getExtraHours(data: datesData): void {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/extra-hours'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }

  /**
   * Call to the end-point to generate indident project fees per employee
   * @param data  initial and end date formated to create the url to call the end-point
   */
  getProjectFeesEmployee(data: datesData): void {
    this.dates = {
      'dates': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/employee/project-fee-employee'//?dateEnd=' + data.dateEnd + '&dateInit=' + data.dateInit
    };
    //window.open(this.dates.dates, '_blank');
    this.exportExcel(this.dates.dates, data);
  }
}
